import {CircularProgress, InputLabel} from "@mui/material";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import FormControl from "@mui/material/FormControl";
import * as React from "react";
import {Check} from "@mui/icons-material";

import {postAPI} from "../api";
import {useState} from "react";

interface SiteScanP {
    notif: (m: string) => void;
}

export default function SiteScan({notif}: SiteScanP) {

    const [url, setUrl] = useState<string>(localStorage.getItem("site-url") ?? "https://");
    const [proc, setProc] = useState<boolean>(false);


    const req = () => {

        if (!url) return notif("url field is empty");
        if (!url.startsWith("http")) {
            return notif("You must specify the site protocol");
        }

        setProc(true);
        postAPI("/site_url", {"url": url}).then(([ok, status, msg]) => {
            localStorage.setItem("site-url", url)
            setProc(false);
            if (ok) {
                notif(msg.resp)
            } else {
                notif("Scan still progress...")
            }
        })
    }

    return (
        <div style={{display: "flex", alignItems: "center", justifyContent: "center"}}>
            <FormControl id="site-scan-field" sx={{width: "90%", transition: "background-color 0.4s"}} onKeyDown={(e) => {
                if (e.keyCode === 13) req();
            }}>
                <InputLabel sx={{userSelect: "none"}}>site url</InputLabel>
                <OutlinedInput
                    onChange={(e) => setUrl(e.target.value)}
                    value={url}
                    endAdornment={
                        <InputAdornment position="end">
                            <IconButton
                                edge="end"
                                onClick={req}
                            >
                                {!proc ? <Check/> : <CircularProgress/>}
                            </IconButton>
                        </InputAdornment>
                    }
                />
            </FormControl>
        </div>
    )
}